<template>
  <div class="wrapper">
    <div v-if="showjd" class="fund-read-wrapper">
      <div class="fund-read linebottomg"
      v-for="(item, index) in showModule"
      :key="`index1${index}`"
      @click="clickCell(item, index)">
        <div class="fund-info">
          <div class="small-tag">{{item.computedReadType}}</div>
          <div class="read-title">{{item.readtitle}}</div>
          <div class="read-time">{{item.updatetimestr}}</div>
        </div>
      </div>
      <div class="fund-read linebottomg"
      v-for="(item, index) in getGXMAD(baseInfo)"
      :key="`index2${index}`"
      @click="clickCell(item, index)">
        <div class="fund-info">
          <div class="small-tag">{{item.TipText}}</div>
          <div class="read-title">{{item.Title}}</div>
          <div class="read-time"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import NativeMsg from '@/base/NativeMsg';
import FundTypeSearch from '@/utils/FundTypeSearch';
import { mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {
      fundCode: '',
      fundType: '',
      fundReportData: {},
      showModule: [],
      showzb: false,
      showjd: false,
      rewardlist: [],
      zbItem: {
      },
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    this.handleDefault();
    this.render(false);
  },

  computed: {
    ...mapGetters({
      baseInfo: 'currentADConDate',
    }),
  },
  mounted() {},
  methods: {
    clickShowzb() {
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/58ae9eec953925afc96b3d9260a4916d/pages/index/index?showId=${this.zbItem.Id}`,
      });
      this.reportMonitor({
        eventName: 'pz.tbkp.zbnr.click',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    async render(isCache) {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      if (!isCache) {
        await this.$store.dispatch('updateFundVarietyByFundCode', this.fundCode).catch((e) => {
          console.log(e);
        });
        NativeMsg.post(JSON.stringify({ key: 'reflashHQB', value: { v: 'start' } }));
      }
      const fundData = this.$store.state.cfhModules.fund[this.fundCode];
      console.log('updateFundVarietyByFundCode');
      if (!fundData) {
        this.configureZBData();
        return;
      }
      this.fundReportData = fundData;
      this.formatModules();
      this.showjd = true;
      this.configureZBData();
    },
    async configureZBData() {
      this.zbItem = {};
      this.confgiRewardLsit();
      this.showjd = true;
      this.showzb = false;
    },
    sortKey(array, key) {
      return array.sort((a, b) => {
        const x = a[key];
        const y = b[key];
        if (x < y) {
          return 1;
        }
        if (x > y) {
          return -1;
        }
        return 0;
      });
    },
    confgiRewardLsit() {
      let list = [];
      if (this.zbItem && this.zbItem.LiveRewardNewList) {
        const luckRewards = this.sortKey(this.zbItem.LiveRewardNewList, 'RewardType');
        if (luckRewards && luckRewards.length >= 0) {
          list = luckRewards;
        }
      }
      if (list && list.length >= 2) {
        const newList = list.slice(0, 2);
        this.rewardlist = newList;
      }
    },
    handleDefault() {},
    formatModules() {
      const { fundread, fundreport } = this.fundReportData;
      const productList = [];
      if (fundread) {
        fundread.forEach((item) => {
          productList.push(item);
        });
      }
      if (fundreport) {
        fundreport.forEach((item) => {
          productList.push(item);
        });
      }
      if (productList.length > 0) {
        let allList = productList;
        allList = allList.filter((item) => item.link).map((item) => {
          const result = item;
          if (result.readtype) {
            result.computedReadType = result.readtype.name;
          } else {
            result.computedReadType = '市场';
          }
          result.Link = {
            LinkTo: item.link.linkTo,
            LinkType: item.link.linkType,
          };
          return result;
        });
        this.showModule = allList;
      }
    },
    clickCell(item, index) {
      const { LinkType, LinkTo } = item.Link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      this.reportMonitor({
        eventName: `pz.jdnr.${index}`,
        location: LinkTo,
        eventContent: {
          location: LinkTo,
        },
      });
    },
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
    getConfigureDataState(item) {
      // FundType 1-权益 2-货币 3-场内 4-新发
      if (!item) {
        return false;
      }
      const {
        ExcludeCodes,
        FundType,
        IncludeCodes,
      } = item;
      if (IncludeCodes && IncludeCodes.indexOf) {
        if (IncludeCodes.indexOf(this.fundCode) !== -1) {
          return true;
        }
      }
      if (ExcludeCodes && ExcludeCodes.indexOf) {
        if (ExcludeCodes.indexOf(this.fundCode) !== -1) {
          return false;
        }
      }
      if (FundType) {
        const liststr = FundType;
        if (liststr.indexOf) {
          if (liststr.indexOf('1') !== -1) {
            if (!this.isNewFund() && !this.isExchangeFund() && !this.isMonetaryfund()) {
              return true;
            }
          }
          if (liststr.indexOf('2') !== -1) {
            if (this.isMonetaryfund()) {
              return true;
            }
          }
          if (liststr.indexOf('3') !== -1) {
            if (this.isExchangeFund()) {
              return true;
            }
          }
          if (liststr.indexOf('4') !== -1) {
            if (this.isNewFund()) {
              return true;
            }
          }
        }
      }
      return false;
    },
    getGXMAD(variInfo) {
      if (!variInfo) {
        return [];
      }
      let ModulesData = null;
      const { datas } = variInfo;
      if (datas) {
        if (datas.Modules) {
          ModulesData = datas.Modules;
        }
      }
      if (ModulesData) {
        const showModules = ModulesData.filter(
          (item) => (item.ModuleCode === 'FundDetailMiddleAd' && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => item.Title).map((item) => {
            const result = item;
            return result;
          });
          return this.cutItemNotiNConfigure(CustomArray);
        }
      }
      return [];
    },
    cutItemNotiNConfigure(list) {
      const showls = [];
      if (!list) {
        return showls;
      }
      list.forEach((element) => {
        if (this.getConfigureDataState(element)) {
          showls.push(element);
        }
      });
      return showls;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper{
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}
.fund-read-wrapper {
  background: #fff;
  border-radius: 12px;
}

.fund-read {
  padding: 21px 0px 21px 0;
  margin-left: 24px;
  margin-right: 24px;
}

.fund-info {
  display: flex;
  align-items: center;
  justify-content: center;
}

.read-title {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #000000;
  letter-spacing: 0;
  text-align: justify;
  padding: 8px 10px;
  padding-left: 0px;
  margin-left: 16px;
  flex: 1;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.spabSpview{
  background: #f5f5f5;
  height: 24px;
}
.read-time {
  font-family: DINAlternate-Bold;
  font-size: 26px;
  padding: 8px 0px;
  color: #999999;
  letter-spacing: 0;
  text-align: right;
}

.read-text {
  margin-top: 20px;
  display: block;
  line-height: 42px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
}

.small-tag {
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  height: 32px;
  align-items: center;
  justify-content: center;
  color: #52a2ff;
  background-color: rgba(82, 162, 255, 0.1);
}

.tag-blue {
  color: #52a2ff;
}

.tag-red {
  color: #52a2ff;
}

.tag-orange {
  color: #52a2ff;
}
.zb-img{
  width: 98px;
  height: 98px;
  border-radius: 49px;
  background: #FFEDE7;
}
.leftzbView{
  margin-left: 30px;
  height: 120px;
  position: relative;
}
.fb-img{
  width: 24px;
  height: 24px;
}
.right-arrow-a{
  width: 30px;
  height: 100px;
  position: absolute;
  right: 54px;
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
}

.right-arrow-v{
  width: 30px;
  height: 30px;
}
.zb-bv{
  margin-bottom: 30px;
  border-radius: 12px;
}
.zb-main{
  flex-direction: row;
  align-items: center;
  display: flex;
  flex: 1;
  background: #fff;
  border-radius: 12px;
}
.zb-row{
  flex-direction: row;
  align-items: center;
  display: flex;
  margin-bottom: 16px;
}
.zb-row-max{
  flex-direction: row;
  align-items: center;
  display: flex;
  margin-bottom: 20px;
  width: 100%;
}
.zb-left{
  flex-direction: column;
  align-items: flex-start;
  margin-top: 42px;
  margin-left: 20px;
  margin-right: 30px;
  display: flex;
  flex: 1;
  margin-bottom: 28px;
}
.zb-in{
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  padding-left: 15px;
  padding-right:15px;
  height: 36px;
  width: 68px;
  border-radius: 18px;
  position: absolute;
  bottom: 0px;
  background-image: linear-gradient(to right,#ff2d00 , #ff7748);
}
.zb-out{
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  padding-left: 15px;
  padding-right:15px;
  height: 36px;
  width: 68px;
  border-radius: 18px;
  position: absolute;
  bottom: 0px;
  background-image: linear-gradient(to right,#3689FF , #2DA3F7);
}
.zb-outy{
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  padding-left: 15px;
  padding-right:15px;
  height: 36px;
  width: 68px;
  border-radius: 18px;
  position: absolute;
  bottom: 0px;
  background-image: linear-gradient(to right,#FFA41B , #FFCE63);
}
.zb-intitle{
  color: #fff;
  white-space:nowrap;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  align-items: center;
  justify-content: center;
}
.zb-title{
  color: #000;
  font-family: PingFangSC-Regular;
  font-size: 30px;
  margin-right: 60px;
  line-height: 35px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.zb-row-rw{
  flex-direction: row;
  align-items: center;
  display: flex;
  margin-top: 5px;
}
.zb-mtitle{
  color: #666;
  font-family: PingFangSC-Regular;
  font-size: 24px;
}
.zb-mtitle-aw{
  color: #ff4400;
  font-family: PingFangSC-Regular;
  width: 120px;
  font-size: 24px;
}
.zb-mtitle-aw-t{
  color: #666666;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.zb-mtitle-aw-item{
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
}
.zb-mtitle-aw-item-point{
  background: #ff4400;
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 4px;
}
</style>
